<template>
  <div>
    <!-- Greeting skeleton -->
    <div class="mb-6">
      <skeleton width="240px" height="28px" class-name="mb-2"></skeleton>
      <skeleton width="160px" height="14px"></skeleton>
    </div>

    <!-- Stats strip skeleton -->
    <div class="flex bg-white border border-black/6 rounded-[20px] shadow-[0_2px_12px_rgba(0,0,0,0.04)] mb-5">
      <div v-for="i in 4" :key="i" class="flex-1 flex flex-col gap-2 py-[18px] px-6" :class="{ 'border-r border-black/6': i < 4 }">
        <skeleton width="48px" height="28px"></skeleton>
        <skeleton width="72px" height="13px"></skeleton>
      </div>
    </div>

    <!-- Cards grid skeleton -->
    <div class="grid grid-cols-2 gap-4 max-[1100px]:grid-cols-1">
      <div v-for="i in 4" :key="'c'+i" class="bg-white border border-black/6 rounded-[20px] p-5 shadow-[0_2px_12px_rgba(0,0,0,0.04)]">
        <div class="flex items-center gap-2 mb-4">
          <skeleton width="80px" height="12px"></skeleton>
          <skeleton width="22px" height="18px" rounded="50px"></skeleton>
        </div>
        <div class="flex flex-col gap-3">
          <div v-for="j in 3" :key="j" class="flex items-center gap-2.5">
            <skeleton width="30px" height="30px" rounded="50%"></skeleton>
            <div class="flex-1 flex flex-col gap-1">
              <skeleton width="120px" height="14px"></skeleton>
              <skeleton width="80px" height="12px"></skeleton>
            </div>
            <skeleton width="56px" height="22px" rounded="50px"></skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonOverview',
  components: { Skeleton }
}
</script>
